import { NIcon } from '@innersource-nn/novoui-react';
import InboxIcon from 'assets/icons/InboxIcon';
import clsx from 'clsx';

interface InfoStateNotificationsProps {
    error: boolean;
}
export default function InfoStateNotifications({
    error,
}: InfoStateNotificationsProps) {
    return (
        <div className="empty-place-holder mt-12">
            <div className="flex flex-col items-center">
                <div
                    className={clsx(
                        error ? 'bg-lava-red-200' : 'bg-light-blue-200',
                        'round-div-icon-middle  h-[5rem]	w-[5rem] ',
                    )}
                >
                    {error ? (
                        <NIcon
                            iconName="warning"
                            size={42}
                            className="w-1/2 h-1/2 fill-true-blue"
                        />
                    ) : (
                        <InboxIcon className="w-40 h-40" />
                    )}
                </div>
                <p className="text-true-blue w-1/2 text-center mt-8">
                    {error
                        ? 'Looks like our notifications are playing hide-and-seek. Ready to find them? Click the refresh button and watch the magic happen'
                        : 'Your notification mailbox is feeling a bit empty. No worries, the digital postman will deliver some updates shortly!'}
                </p>
            </div>
        </div>
    );
}
